module.exports = __webpack_public_path__ + "img/插图.ae5a05d4.png";